exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.onetime-btn-base[data-v-53a233f2] {\n  font-size: 1.0rem;\n  text-align: center;\n  width: 190px;\n  height: 40px;\n  box-sizing: border-box;\n  background: #ffa300;\n}\n.change-phone-number[data-v-53a233f2] {\n  box-sizing: border-box;\n  width: 400px;\n  padding: 6px;\n  border: 1px solid #ff9fae;\n  margin-right: 20px;\n}\n.change-phone-number-btn[data-v-53a233f2] {\n  font-size: 1.0rem;\n  text-align: center;\n  width: 70px;\n  height: 40px;\n  box-sizing: border-box;\n  background: #ffa300;\n}\n", ""]);

// exports
